import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const MUTUACORE_API_URL = process.env.REACT_APP_MUTUACORE_API_URL || 'https://sso.mutuacore.fr';
const API_URL = process.env.REACT_APP_API_URL;

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [company, setCompany] = useState('');
  const [plan, setPlan] = useState('Diagnostic Pro');
  const [error, setError] = useState('');

  const [isProcessing, setIsProcessing] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const savedPlan = localStorage.getItem('planChoisi');
    if (savedPlan) setPlan(savedPlan);
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setIsProcessing(true);

    try {
      const response = await fetch(`${MUTUACORE_API_URL}/auth/inscription-entreprise`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          mot_de_passe: password,
          nom,
          prenom,
          nom_entreprise: company
        })
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);

        const pendingPriceId = localStorage.getItem('pendingPriceId');
        const pendingPlanType = localStorage.getItem('pendingPlanType');

        if (pendingPriceId) {
          try {
            const stripeResponse = await fetch(`${API_URL}/create-checkout-session`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ price_id: pendingPriceId, mode: pendingPlanType })
            });

            const stripeData = await stripeResponse.json();

            localStorage.removeItem('pendingPriceId');
            localStorage.removeItem('pendingPlanType');

            if (stripeData.url) {
              window.location.href = stripeData.url;
              return;
            } else {
              setError("Erreur Stripe : " + stripeData.error);
              setIsProcessing(false);
            }
          } catch (stripeErr) {
            console.error("Erreur réseau Stripe :", stripeErr);
            setError("Erreur de connexion au serveur de paiement.");
            setIsProcessing(false);
          }
        } else {
          navigate('/dashboard');
        }
      } else {
        setError(data.detail || 'Erreur lors de la création du compte.');
        setIsProcessing(false);
      }
    } catch (err) {
      console.error("Erreur register:", err);
      setError('Erreur de connexion au serveur sécurisé.');
      setIsProcessing(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ecf0f1', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
        <h2 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '10px' }}>Créer votre compte</h2>
        <p style={{ textAlign: 'center', color: '#7f8c8d', marginBottom: '30px' }}>Forfait sélectionné : <b>{plan}</b></p>

        {error && <div style={{ background: '#e74c3c', color: 'white', padding: '10px', borderRadius: '5px', marginBottom: '20px', textAlign: 'center', fontSize: '14px' }}>{error}</div>}

        <form onSubmit={handleRegister}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#34495e', fontWeight: 'bold' }}>Nom de l'entreprise</label>
            <input type="text" required value={company} onChange={(e) => setCompany(e.target.value)} disabled={isProcessing} style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc', boxSizing: 'border-box' }} placeholder="Ex: Tech Solutions" />
          </div>

          <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: '5px', color: '#34495e', fontWeight: 'bold' }}>Prénom</label>
              <input type="text" required value={prenom} onChange={(e) => setPrenom(e.target.value)} disabled={isProcessing} style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc', boxSizing: 'border-box' }} placeholder="Jean" />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: '5px', color: '#34495e', fontWeight: 'bold' }}>Nom</label>
              <input type="text" required value={nom} onChange={(e) => setNom(e.target.value)} disabled={isProcessing} style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc', boxSizing: 'border-box' }} placeholder="Dupont" />
            </div>
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#34495e', fontWeight: 'bold' }}>Email professionnel</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} disabled={isProcessing} style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc', boxSizing: 'border-box' }} placeholder="contact@entreprise.com" />
          </div>

          <div style={{ marginBottom: '30px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#34495e', fontWeight: 'bold' }}>Mot de passe</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} disabled={isProcessing} style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc', boxSizing: 'border-box' }} placeholder="••••••••" />
          </div>

          <button type="submit" disabled={isProcessing} style={{ width: '100%', padding: '12px', background: isProcessing ? '#95a5a6' : '#3498db', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold', fontSize: '16px', cursor: isProcessing ? 'wait' : 'pointer', transition: '0.3s' }}>
            {isProcessing ? "Sécurisation en cours..." : "Accéder à mon espace"}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '14px', color: '#7f8c8d' }}>
          Déjà un compte ? <Link to="/login" style={{ color: '#3498db', textDecoration: 'none', fontWeight: 'bold' }}>Se connecter</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;